export const SET_CURRENT_CHANNEL =  'SET_CURRENT_CHANNEL';
export const SET_PRIVATE_CHANNEL =  'SET_PRIVATE_CHANNEL';

export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const FETCH_CHATMESSAGES = 'FETCH_CHATMESSAGES'